import { conformToMask } from 'react-text-mask';

import CheckmarkSmallSvg from '@/components/common/CheckmarkSmallSvg';
import { TmAddress } from '@/tscapi/model/account';

interface DisplayAddressCardProps {
    addressData: TmAddress;
    type: string;
}
export const DisplayAddressCard = (props: DisplayAddressCardProps) => {
    const { addressData, type } = props;
    const phoneNumberMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    const postalCodeMask = [/[A-Z]/i, /\d/, /[A-Z]/i, ' ', /\d/, /[A-Z]/i, /\d/];
    return (
        <>
            <div className="relative mt-1 flex h-56 flex-col flex-wrap border-4 border-solid border-[#d1dde2] bg-white px-7 py-6 text-base font-light " data-qm-encrypt="true">
                <div>
                    <span className="mr-1">{addressData.FirstName}</span>
                    <span>{addressData.LastName}</span>
                </div>
                <div>{addressData.Street}</div>
                <div>
                    <span className="mr-1">{addressData.City},</span>
                    <span>{addressData.State}</span>
                </div>
                {addressData.ZipCode && (
                    <div>{conformToMask(addressData.ZipCode, postalCodeMask, { guide: false }).conformedValue}</div>
                )}
                {addressData.DayPhone && (
                    <div>{conformToMask(addressData.DayPhone, phoneNumberMask, { guide: false }).conformedValue}</div>
                )}

                <div className="absolute bottom-7 flex h-3 text-xs font-semibold">
                    {addressData.IsDefault && (
                        <>
                            <CheckmarkSmallSvg className="mr-1" /> Default shipping address
                        </>
                    )}
                </div>
            </div>
        </>
    );
};
